module.exports = __webpack_public_path__ + "images/7327582f15d8d33e069d6c7ecd445463-illu_newBox_DoorWindowSensor.png";